var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"space-y-4"},[(_vm.members.length > 0)?_vm._l((_vm.members),function(member,idx){return _c('member',{key:idx,attrs:{"member":member}})}):_c('div',[_vm._v("No Members")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }